import { provideAppInitializer, inject } from "@angular/core";
import { ConfigService } from "../services/config";

export function provideConfigInitializer() {
  return provideAppInitializer(() =>
    inject(ConfigService)
      .load()
      .catch((err) => {
        console.error("Config load failed", err);
        return {};
      })
  );
}
